import React from "react";
import { useEditCtaContext } from "../../../../../../context/EditCtaContext";
import ContentOneImageUpload from "./ContentOneImageUpload";

const ContentImageGroup = () => {
  const { getCurrentStep } = useEditCtaContext();
  console.log("Rendering ContentImageGroup");
  return (
    <div className="flex flex-col px-6 pb-6 min-h-[400px]">
      {/* Step Header */}
      <div className="flex flex-col pt-4 mb-12">
        <h2 className="text-white text-2xl font-semibold leading-[30px] tracking-[-0.15px] mb-0">
          Step {getCurrentStep() + 1}
        </h2>
        <p className="text-white text-xl font-medium leading-6">
          Pick your Image
        </p>
      </div>

      {/* Form Fields */}
      <div className="flex flex-col gap-3">
        {/* Font Size Selector */}
        <div className="flex flex-col gap-1">
          <ContentOneImageUpload />
        </div>
      </div>
    </div>
  );
};

export default ContentImageGroup;
